<template xmlns:v-popover="">
  <el-row>
    <!-- This implementation is a bit tricky since it saves a variable called row that gets the current row and the button is showed only when the row is less than 2, so only the first one -->
    <el-tooltip class="item" effect="dark" content="Delete all rows" placement="top-start">
      <el-button v-show="row<2" id='resetButton' v-on:click='reset' v-popover:popOverDelete>Delete</el-button>
    </el-tooltip>
    <!-- Parameter select (FPGA Version, Temperature...) -->
    <el-tooltip class="item" effect="dark" content="Select an input parameter" placement="top-start">
      <el-col :span="4">
        <el-select :disabled="!buttonClicked" v-model="field" filterable placeholder="Select" v-popover:popOverInputParam>
          <el-option
            v-for="element in listParams"
            :key="element.code"
            :label="element.name"
            :value="element.code">
          </el-option>
        </el-select>
      </el-col>
    </el-tooltip>

    <!-- Operator select (> < =) -->
    <el-col :span="4">
      <el-select :disabled="!buttonClicked" v-show="field!=''" v-model="selectedOperator" placeholder="> < =">
        <el-option
          v-for="element in operators"
          :key="element"
          :label="element"
          :value="element">
        </el-option>
      </el-select>
    </el-col>

    <!-- Input operation (number, string ...) -->
    <el-tooltip class="item" effect="dark" content="Input a valid value" placement="top-start">
      <el-col :span="4">
        <el-input :disabled="!buttonClicked" v-show="selectedOperator!=''" v-model="valueSelect" v-popover:popOverValue></el-input>
      </el-col>
    </el-tooltip>

    <!-- Logical operator select -->
    <el-col :span="4">
      <el-select :disabled="!buttonClicked" v-model="selectedLogicalOperator" v-show="valueSelect!=''" placeholder="AND  OR">
        <el-option
          v-for="item in logicalOperators"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
    </el-col>

    <el-button v-show="buttonClicked && field!='' && selectedOperator!='' && valueSelect!='' && selectedLogicalOperator!=''" v-on:click='addRow'>Add</el-button>

  </el-row>
</template>

<script>
  export default {
    name: 'QuerySelection',
    props:['listParams', 'rowNumber', 'queryParameters'],
    data() {
      return {
        row: this.rowNumber,
        buttonClicked: true,
        field: '',
        valueSelect: '',
        selectedOperator: '',
        selectedLogicalOperator: '',
        query: '',
        operators: [
          '>',
          '<',
          '='
        ], /* Operators (< > =) */
        logicalOperators: [
          'AND',
          'OR',
        ], /* Logical operators (AND, OR) */
      }
    },
    methods:{
      addRow: function () {
        // This is an easy fix for the SQL database problem (doesn't accept upper case characters)
        if (this.field === this.field.toUpperCase()) {
          this.field += '1';
        }
        this.query = `${this.field}${this.selectedOperator}${this.valueSelect} ${this.selectedLogicalOperator} `; /* Example: h > 125 */
        this.$emit('update:rowNumber', this.rowNumber+1)
        this.$emit('update:queryParameters', this.queryParameters.push(this.query))
        this.buttonClicked = false;

      },
      reset: function () {
        this.field = '';
        this.valueSelect = '';
        this.selectedOperator = '';
        this.selectedLogicalOperator = '';
        this.$emit('update:rowNumber', 1)
        this.$emit('update:queryParameters', this.queryParameters.length = 0)
        this.buttonClicked = true;
      },
    }
  }
</script>

<style  scoped>
  #resetButton{
    position: absolute;
    right: 5%;
  }
</style>



// WEBPACK FOOTER //
// src/components/QuerySelection.vue